export default {
  // 基本信息
  基本信息: "基本信息",
  商单名称: "商单名称",
  请输入商单名称: "请输入商单名称",
  最多可输入50个字符: "最多可输入50个字符",
  请输入: "请输入",
  商单总预算: "商单总预算",
  支付给达人的目标预算: "支付给达人的目标预算",
  请输入商单总预算: "请输入商单总预算",
  仅可输入数字和小数点: "仅可输入数字和小数点",
  预计报名时间: "预计报名时间",
  请选择预计报名时间: "请选择预计报名时间",
  预计交付时间: "预计交付时间",
  请选择预计交付时间: "请选择预计交付时间",
  提交: "提交",

  // 品牌介绍
  品牌介绍: "品牌介绍",
  "向达人更好地了解品牌，提升接单可能性": "向达人更好地了解品牌，提升接单可能性",
  品牌名称: "品牌名称",
  品牌Logo: "品牌Logo",
  请上传文件: "请上传文件",
  "支持扩展名：.jpg .png…": "支持扩展名：.jpg .png…",
  请输入备注: "请输入备注",

  // 达人要求
  达人要求: "达人要求",
  满足设置要求的达人才可参加商单并申样: "满足设置要求的达人才可参加商单并申样",
  粉丝量级: "粉丝量级",
  "粉丝量≥": "粉丝量≥",
  仅支持输入整数: "仅支持输入整数",
  请输入粉丝量: "请输入粉丝量",
  目标达人数: "目标达人数",
  请输入目标达人数: "请输入目标达人数",
  "商单预算/人": "商单预算/人",
  请输入商单预算: "请输入商单预算",

  // 商品信息
  商单商品: "商单商品",
  商品信息: "商品信息",
  修改商品: "修改商品",
  添加商品: "添加商品",
  "达人佣金%": "达人佣金%",
  "Youpik佣金%": "Youpik佣金%",
  商品ID: "商品ID",
  所属店铺: "所属店铺",
  店铺短码: "店铺短码",
  库存: "库存",
  佣金: "佣金",
  商品内容不能为空: "商品内容不能为空",

  // 脚本和视频
  脚本范例: "脚本范例",
  请选择脚本范例: "请选择脚本范例",
  请输入文案链接: "请输入文案链接",
  请输入有效链接: "请输入有效链接",
  添加脚本范例: "添加脚本范例",
  参考视频: "参考视频",
  参考视频类型: "参考视频类型",
  请选择视频类型: "请选择视频类型",
  本地视频: "本地视频",
  TikTok视频链接: "TikTok视频链接",
  请输入视频链接: "请输入视频链接",
  "请输入 TikTok 视频链接": "请输入 TikTok 视频链接",
  添加参考视频: "添加参考视频",

  // 商单列表
  video: "视频",
  Live: "直播",
  LiveAndVideo: "直播和视频",
  进行中: "进行中",
  已交付: "已交付",
  已取消: "已取消",
  复制商单: "复制商单",
  编辑商单: "编辑商单",
  交付商单: "交付商单",
  取消商单: "取消商单",
  商单编号: "商单编号",
  当前预估支出: "当前预估支出",
  实际支出: "实际支出",
  粉丝数k: "粉丝数≥{num}",
  接单达人数: "接单达人数",
  交付视频数: "交付视频数",
  商单PM: "商单PM",
  创建时间: "创建时间",
  交付时间: "交付时间",
  交付人: "交付人",

  // 商单详情
  分享商单: "分享商单",
  进入工作台: "进入工作台",

  ///
  新增商单: "新增商单",
  查看进度: "查看进度",
  工作台: "工作台",
  查看详情: "查看详情",
  总预算: "总预算",
  交付要求: "交付要求",
  交付内容: "交付内容",
  TAP挂链: "TAP挂链",
  视频: "视频",
  必须: "必须",
  非必须: "非必须",
  "Ads Code": "Ads Code",
  内容数量: "内容数量",
  内容时长: "内容时长",
  秒: "秒",
  Hashtag: "Hashtag",
  添加: "添加",
  添加商单商品: "添加商单商品",
  商品: "商品",
  商品名称: "商品名称",
  商品价格: "商品价格",
  人: "人",
  份: "份",
  活动ID: "活动ID",
  商家短码: "商家短码",
  商家名称: "商家名称",
  活动: "活动",
  可用: "可用",
  不可用: "不可用",
  状态: "状态",
  商家: "商家",
  目标接单达人: "目标接单达人",
  邀约达人时间: "邀约达人时间",
  "平均预算/达人": "平均预算/达人",
  目标总预算: "目标总预算",
  目标交付时间: "目标交付时间",
  预算把控: "预算把控",
  目标预算: "目标预算",
  "该商单开始时PM设置的总达人预算。": "该商单开始时PM设置的总达人预算。",
  预计支出: "预计支出",
  "已接单达人的最终报价之和。": "已接单达人的最终报价之和。",
  "商单完结后,已接单达人的最终报价之和,未完结前计为0。":
    "商单完结后,已接单达人的最终报价之和,未完结前计为0。",
  达人进度: "达人进度",
  邀约达人数: "邀约达人数",
  申样达人数: "申样达人数",
  交付达人数: "交付达人数",
  已打款达人数: "已打款达人数",
  内容进度: "内容进度",
  目标内容数: "目标内容数",
  内容交付: "内容交付",
  合格内容: "合格内容",
  不合格内容: "不合格内容",
  交付效果: "交付效果",
  总播放量: "总播放量",
  总点赞数: "总点赞数",
  总评论数: "总评论数",
  总销售件数: "总销售件数",
  商单交付提醒: "商单交付提醒",
  "交付后达人无法进行邀请、接单、申样、履约等操作":
    "交付后达人无法进行邀请、接单、申样、履约等操作",
  "，你还要继续吗？": "，你还要继续吗？",
  商单取消提醒: "商单取消提醒",
  "取消后达人无法进行邀请、接单、申样、履约等操作":
    "取消后达人无法进行邀请、接单、申样、履约等操作",
  取消时间: "取消时间",
  操作人: "操作人",
  全部PIC: "全部PIC",
  "最多只能上传 {maxLength} 个文件": "最多只能上传 {maxLength} 个文件",
  确认提交: "确认提交",
  修改后达人邀请信息将同步修改: "修改后达人邀请信息将同步修改",
  仅支持输入数字和小数点: "仅支持输入数字和小数点",
  //
  请输入有效的URL链接: "请输入有效的URL链接",
  "请输入 Ads code": "请输入 Ads code",
  "仅可输入数字和小数点，最多两位小数": "仅可输入数字和小数点，最多两位小数",
  确认创建: "确认创建",
  视频不大于50M: "视频不大于50M",
  图片不大于5M: "图片不大于5M",
  视频链接重复: "视频链接重复",
  内容: "内容",
  adsCode码重复: "adsCode码重复",
  查看数据: "查看数据",
  最多添加10个标签: "最多添加10个标签",
  仅可输入整数: "仅可输入整数",
  总订单数: "总订单数",
  返回: "返回",
  单: "单",
  "达人发布内容后，将以该要求做为检测合格的标准": "达人发布内容后，将以该要求做为检测合格的标准",
  "符合以上粉丝量级的接受商单目标达人人数。": "符合以上粉丝量级的接受商单目标达人人数。",
  "和达人谈单时不可超过该预算。": "和达人谈单时不可超过该预算。",
  确认取消保存: "确认取消保存",
  取消后编辑的内容将不会保存: "取消后编辑的内容将不会保存"
};
